import { render, staticRenderFns } from "./recordReport.vue?vue&type=template&id=30303d12&scoped=true&"
import script from "./recordReport.vue?vue&type=script&lang=js&"
export * from "./recordReport.vue?vue&type=script&lang=js&"
import style0 from "./recordReport.vue?vue&type=style&index=0&id=30303d12&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30303d12",
  null
  
)

export default component.exports